import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Loader } from "@vds/loaders";
import RedesignedBreadCrumbs  from "../../components/common/RedesignedBreadCrumbs";
const IframeWrapper = styled.div`
  padding-top: 2rem;
  height: 80vh;
  @media (max-width: 540px) {
    height: 78vh;
  }
  @media (min-width: 768px) and (max-width: 960px) {
    height: 80vh;
  }
  @media (min-width: 1024px) {
    height: 80vh;
  }
  @media (min-width: 1600px) {
    height: 85vh;
  }
`;

const CustomBreadcrumbsWrapper = styled.div`
  li > div {
    display: none;
  }
`;

const BreadcrumbsSpan = styled.span`
  color: ${(props) => (props.color ? props.color : "#000000")};
  font-size: 0.875rem;
  font-family: Neue Haas Grotesk Text Std;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  line-height: 0.875rem;
  cursor: ${(props) => (props.cursor ? props.cursor : "")};
`;

const MobileBreakPoint = 481;

function ManagePayment(props) {
  const [t] = useTranslation("billingTranslation");
  const [isLoading, setIsLoading] = useState(false);
  const BreadcrumbsItemsList = [
  {
    name: t("Billing and payment"),
    id: "billing-and-payment-back-link",
  },
  { name: `${props.actionCode === "Manage Wallet" ? t("Manage Payment Methods") : t("Make a Payment")}`, id: "manage-payment_props.actionCode" },
  
];
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, []);

  return (
    <div>
      {/* Added RedesignedBreadCrumbs component which will be common for both Mobile and Desktop */}
      <RedesignedBreadCrumbs Items={BreadcrumbsItemsList} handleBack={props.closePayment}></RedesignedBreadCrumbs>
      
      {/* Code for displaying VEPS page */}
      <IframeWrapper>
        <Loader active={isLoading} fullscreen={true} />
        <iframe
          src={props.vepsURL}
          className="veps-Iframe"
          title={props.actionCode === "Manage Wallet" ? "Manage Payment Methods" : "Make a Payment"}
        >
          {t("Sorry, your browser does not support inline frames.")}
        </iframe>
      </IframeWrapper>
    </div>
  );
}
ManagePayment.propTypes = {
  actionCode: PropTypes.string.isRequired,
  closePayment: PropTypes.func,
  vepsURL: PropTypes.string
};

export default ManagePayment;
